<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container equipment-wrapper">
  <div class="equipment-wrapper__item">
    <h2 class="equipment-wrapper__item__title">
      {{ viewDesign?.hvac_dsn_descrpt }}
    </h2>
    <p class="equipment-wrapper__item__detail">
      ID: {{ viewDesign?.hvac_design_id }}<br />
    </p>
    <button mat-flat-button color="accent" [routerLink]="['/design']">
      Select Other Design
    </button>
  </div>
  <h2>Systems</h2>
  <hr />
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link">Systems</a>
      </li>
    </ul>
  </div>
  <form action="">
    <div class="input-wrapper">
      <mat-form-field appearance="fill" class="d-flex search-field">
        <mat-icon>search</mat-icon>
        <input matInput [(ngModel)]="searchSystemDesign" name="search" (input)="searchSystemDesigns()"
          placeholder="Placeholder" />
      </mat-form-field>
    </div>
  </form>

  <div class="d-flex justify-content-start">
  <button mat-flat-button color="primary" class="add-new-btn" [routerLink]="['/new-system-design']" [queryParams]="{id: designId, editMode: false}">
    <!--<button mat-flat-button color="primary" class="add-new-btn" [routerLink]="['/system']" [queryParams]="{mode: 2}">-->
    <mat-icon>add</mat-icon> Add System
  </button>
  </div>
  <div class="equipment-wrapper__item" *ngFor="let systemsDesign of systemsDesigns">
    <h2 class="equipment-wrapper__item__title">
      {{ systemsDesign.name }}
    </h2>
    <p class="equipment-wrapper__item__detail" style="font-size:14px;">
      ID: {{ systemsDesign.selection_id }}<br />
      <!--Complete: {{systemsDesign.systemcomplete}} -->
    </p>

    <span>
    <button mat-flat-button color="accent" [routerLink]="['/view-system']"
      [queryParams]="{ id: systemsDesign.selection_id }">
      View System
    </button>
    <button mat-flat-button color="accent" style="background-color: orange;" (click)="removeSystem(systemsDesign.selection_id)">
      Remove System
    </button>
  </span>

  </div>
</div>
